(window["webPackBridgeJsonp"] = window["webPackBridgeJsonp"] || []).push([[0],{

/***/ "10bcd13b17903aef155f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utils; });
/* unused harmony export RecordType */
/* unused harmony export PIIScrubber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PIIKind; });
/* unused harmony export PII */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Record; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DataPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientToCollectorRequest; });
/* harmony import */ var _lib_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("69ef09bc7fd3484310a1");
/* harmony import */ var _lib_bond_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e3f1ab2f47504a835c5c");
/* harmony import */ var _lib_microsoft_bond_collections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1fe0d4d94639de12e325");
// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115



//------------------------------------------------------------------------------
//     This code was generated by using the bondc tool and modified to remove
//      deserialization because it is unused.
//
//     Tool     : bondc, Version=3.0.1, Build=bond-git.debug.not
//     Template : Microsoft.Bond.Rules.dll#TypeScript.tt
//     File     : DataPackage.ts
//
//     Changes to this file may cause incorrect behavior and will be lost when
//     the code is regenerated.
//------------------------------------------------------------------------------
var utils = /** @class */ (function () {
    function utils() {
    }
    utils.GetGuid = function () {
        var rd = function () {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1, 5);
        };
        return [
            rd(),
            rd(),
            "-",
            rd(),
            "-",
            rd(),
            "-",
            rd(),
            "-",
            rd(),
            rd(),
            rd()
        ].join("");
    };
    utils.GetTimeStamp = function () {
        var val = new Date().getTime();
        var timestamp = new _lib_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* Int64 */ "d"]("0");
        timestamp.low = val & 0xffffffff;
        timestamp.high = Math.floor(val / 0x100000000);
        return timestamp;
    };
    utils.GetTimeStampWithValue = function (timestamp) {
        var bond_timestamp = new _lib_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* Int64 */ "d"]("0");
        bond_timestamp.low = timestamp & 0xffffffff;
        bond_timestamp.high = Math.floor(timestamp / 0x100000000);
        return bond_timestamp;
    };
    return utils;
}());

var RecordType;
(function (RecordType) {
    RecordType[RecordType["NotSet"] = 0] = "NotSet";
    RecordType[RecordType["Event"] = 1] = "Event";
    // Deprecated, please use PerformanceCounterAzure and PerformanceCounterGfs instead
    RecordType[RecordType["PerformanceCounter"] = 2] = "PerformanceCounter";
    RecordType[RecordType["Anomaly"] = 3] = "Anomaly";
    RecordType[RecordType["Prediction"] = 4] = "Prediction";
    RecordType[RecordType["TraceLog"] = 5] = "TraceLog";
    RecordType[RecordType["EventSourceLog"] = 6] = "EventSourceLog";
    RecordType[RecordType["HttpLog"] = 7] = "HttpLog";
    RecordType[RecordType["PerformanceCounterAzure"] = 8] = "PerformanceCounterAzure";
    RecordType[RecordType["PerformanceCounterGfs"] = 9] = "PerformanceCounterGfs";
})(RecordType || (RecordType = {}));
var PIIScrubber;
(function (PIIScrubber) {
    PIIScrubber[PIIScrubber["NotSet"] = 0] = "NotSet";
    PIIScrubber[PIIScrubber["O365"] = 1] = "O365";
    PIIScrubber[PIIScrubber["SkypeBI"] = 2] = "SkypeBI";
    PIIScrubber[PIIScrubber["SkypeData"] = 3] = "SkypeData";
})(PIIScrubber || (PIIScrubber = {}));
var PIIKind;
(function (PIIKind) {
    PIIKind[PIIKind["NotSet"] = 0] = "NotSet";
    PIIKind[PIIKind["DistinguishedName"] = 1] = "DistinguishedName";
    PIIKind[PIIKind["GenericData"] = 2] = "GenericData";
    PIIKind[PIIKind["IPV4Address"] = 3] = "IPV4Address";
    PIIKind[PIIKind["IPv6Address"] = 4] = "IPv6Address";
    PIIKind[PIIKind["MailSubject"] = 5] = "MailSubject";
    PIIKind[PIIKind["PhoneNumber"] = 6] = "PhoneNumber";
    PIIKind[PIIKind["QueryString"] = 7] = "QueryString";
    PIIKind[PIIKind["SipAddress"] = 8] = "SipAddress";
    PIIKind[PIIKind["SmtpAddress"] = 9] = "SmtpAddress";
    PIIKind[PIIKind["Identity"] = 10] = "Identity";
    PIIKind[PIIKind["Uri"] = 11] = "Uri";
    PIIKind[PIIKind["Fqdn"] = 12] = "Fqdn";
    // Supports scrubbing of the last octet in a IPV4 address. E.g. 10.121.227.147 becomes 10.121.227.*
    PIIKind[PIIKind["IPV4AddressLegacy"] = 13] = "IPV4AddressLegacy";
    // To scrub file path where it doesn't begin with file: | http: | https: | ftp: etc. known naming conventions
    PIIKind[PIIKind["FilePath"] = 14] = "FilePath";
})(PIIKind || (PIIKind = {}));
var PII = /** @class */ (function () {
    function PII() {
        // 1: optional PIIScrubber ScrubType
        this.ScrubType = PIIScrubber.NotSet;
        // 2: optional PIIKind Kind
        this.Kind = PIIKind.NotSet;
        // 3: optional string RawContent
        this.RawContent = "";
    }
    PII.prototype.Write = function (writer) {
        this.WriteImpl(writer, false /*isBase*/);
    };
    PII.prototype.WriteImpl = function (writer, isBase) {
        writer.WriteStructBegin(null /*metadata*/, isBase);
        if (this.ScrubType != PIIScrubber.NotSet) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 1, null);
            writer.WriteInt32(this.ScrubType);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 1, null);
        }
        if (this.Kind != PIIKind.NotSet) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 2, null);
            writer.WriteInt32(this.Kind);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 2, null);
        }
        if (this.RawContent != "") {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 3, null);
            writer.WriteString(this.RawContent);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 3, null);
        }
        writer.WriteStructEnd(isBase);
    };
    PII.prototype.Read = function (reader) {
        this.ReadImpl(reader, false /*isBase*/);
    };
    // @ts-ignore
    PII.prototype.ReadImpl = function (reader, isBase) { };
    return PII;
}());

var Record = /** @class */ (function () {
    function Record() {
        // 1: optional string Id
        this.Id = utils.GetGuid();
        // 3: optional int64 Timestamp
        this.Timestamp = utils.GetTimeStamp();
        // 5: optional string Type
        this.Type = "";
        // 6: optional string EventType
        this.EventType = "";
        // 13: optional map<string, string> Extension
        this.Extension = new _lib_microsoft_bond_collections__WEBPACK_IMPORTED_MODULE_2__[/* Map */ "a"]();
        // 24: optional RecordType RecordType
        this.RecordType = RecordType.NotSet;
        // 30: optional map<string, PII> PIIExtensions
        this.PIIExtensions = new _lib_microsoft_bond_collections__WEBPACK_IMPORTED_MODULE_2__[/* Map */ "a"]();
    }
    Record.prototype.AddOrReplacePII = function (key, piiValue, piiKind) {
        var pii = new PII();
        pii.RawContent = piiValue;
        pii.Kind = piiKind;
        pii.ScrubType = PIIScrubber.O365;
        this.PIIExtensions.AddOrReplace(key, pii);
    };
    Record.prototype.Write = function (writer) {
        this.WriteImpl(writer, false /*isBase*/);
    };
    Record.prototype.WriteImpl = function (writer, isBase) {
        writer.WriteStructBegin(null /*metadata*/, isBase);
        if (this.Id != "") {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 1, null);
            writer.WriteString(this.Id);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 1, null);
        }
        if (!this.Timestamp.Equals("0")) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT64, 3, null);
            writer.WriteInt64(this.Timestamp);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT64, 3, null);
        }
        if (this.Type != "") {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 5, null);
            writer.WriteString(this.Type);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 5, null);
        }
        if (this.EventType != "") {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 6, null);
            writer.WriteString(this.EventType);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 6, null);
        }
        if (this.Extension.Count()) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_MAP, 13, null);
            writer.WriteMapContainerBegin(this.Extension.Count(), _lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, _lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING);
            for (var i8 = 0; i8 < this.Extension.GetBuffer().length; ++i8) {
                writer.WriteString(this.Extension.GetBuffer()[i8].Key);
                writer.WriteString(this.Extension.GetBuffer()[i8].Value);
            }
            writer.WriteContainerEnd();
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_MAP, 13, null);
        }
        if (this.RecordType != RecordType.NotSet) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 24, null);
            writer.WriteInt32(this.RecordType);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 24, null);
        }
        if (this.PIIExtensions.Count()) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_MAP, 30, null);
            writer.WriteMapContainerBegin(this.PIIExtensions.Count(), _lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, _lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRUCT);
            for (var i66 = 0; i66 < this.PIIExtensions.GetBuffer().length; ++i66) {
                writer.WriteString(this.PIIExtensions.GetBuffer()[i66].Key);
                this.PIIExtensions.GetBuffer()[i66].Value.WriteImpl(writer, false);
            }
            writer.WriteContainerEnd();
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_MAP, 30, null);
        }
        writer.WriteStructEnd(isBase);
    };
    Record.prototype.Read = function (reader) {
        this.ReadImpl(reader, false /*isBase*/);
    };
    // @ts-ignore
    Record.prototype.ReadImpl = function (reader, isBase) { };
    return Record;
}());

var DataPackage = /** @class */ (function () {
    function DataPackage() {
        // 2: optional string Source
        this.Source = "";
        // 5: optional string DataPackageId
        this.DataPackageId = "";
        // 6: optional int64 Timestamp
        this.Timestamp = new _lib_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* Int64 */ "d"]("0");
        // 8: optional vector<clienttelemetry.data.v1.Record> Records
        this.Records = [];
    }
    DataPackage.prototype.Write = function (writer) {
        this.WriteImpl(writer, false /*isBase*/);
    };
    DataPackage.prototype.WriteImpl = function (writer, isBase) {
        writer.WriteStructBegin(null /*metadata*/, isBase);
        if (this.Source != "") {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 2, null);
            writer.WriteString(this.Source);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 2, null);
        }
        if (this.DataPackageId != "") {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 5, null);
            writer.WriteString(this.DataPackageId);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRING, 5, null);
        }
        if (!this.Timestamp.Equals("0")) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT64, 6, null);
            writer.WriteInt64(this.Timestamp);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT64, 6, null);
        }
        if (this.Records.length) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_LIST, 8, null);
            writer.WriteContainerBegin(this.Records.length, _lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRUCT);
            for (var i52 = 0; i52 < this.Records.length; ++i52) {
                this.Records[i52].WriteImpl(writer, false);
            }
            writer.WriteContainerEnd();
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_LIST, 8, null);
        }
        writer.WriteStructEnd(isBase);
    };
    DataPackage.prototype.Read = function (reader) {
        this.ReadImpl(reader, false /*isBase*/);
    };
    // @ts-ignore
    DataPackage.prototype.ReadImpl = function (reader, isBase) { };
    return DataPackage;
}());

var ClientToCollectorRequest = /** @class */ (function () {
    function ClientToCollectorRequest() {
        // 1: optional vector<clienttelemetry.data.v1.DataPackage> DataPackages
        this.DataPackages = [];
        // 2: optional int32 RequestRetryCount
        this.RequestRetryCount = 0;
    }
    ClientToCollectorRequest.prototype.Write = function (writer) {
        this.WriteImpl(writer, false /*isBase*/);
    };
    ClientToCollectorRequest.prototype.WriteImpl = function (writer, isBase) {
        writer.WriteStructBegin(null /*metadata*/, isBase);
        if (this.DataPackages.length) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_LIST, 1, null);
            writer.WriteContainerBegin(this.DataPackages.length, _lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_STRUCT);
            for (var i67 = 0; i67 < this.DataPackages.length; ++i67) {
                this.DataPackages[i67].WriteImpl(writer, false);
            }
            writer.WriteContainerEnd();
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_LIST, 1, null);
        }
        if (this.RequestRetryCount != 0) {
            writer.WriteFieldBegin(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 2, null);
            writer.WriteInt32(this.RequestRetryCount);
            writer.WriteFieldEnd();
        }
        else {
            writer.WriteFieldOmitted(_lib_bond_const__WEBPACK_IMPORTED_MODULE_1__[/* BondDataType */ "a"].BT_INT32, 2, null);
        }
        writer.WriteStructEnd(isBase);
    };
    ClientToCollectorRequest.prototype.Read = function (reader) {
        this.ReadImpl(reader, false /*isBase*/);
    };
    // @ts-ignore
    ClientToCollectorRequest.prototype.ReadImpl = function (reader, isBase) { };
    return ClientToCollectorRequest;
}());



/***/ }),

/***/ "12750d13a8e05f549bfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Utf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Varint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Varint64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Float; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Double; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Zigzag; });
/* unused harmony export DecodingUtf8 */
/* unused harmony export DecodingBase64 */
/* unused harmony export DecodingVarint */
/* unused harmony export DecodingFloat */
/* unused harmony export DecodingDouble */
/* unused harmony export DecodingZigzag */
/* harmony import */ var _microsoft_bond__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("69ef09bc7fd3484310a1");
// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115
// OOO Circular: services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.ts > services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.encoding.ts

var Utf8 = /** @class */ (function () {
    function Utf8() {
    }
    Utf8.GetBytes = function (value) {
        var array = []; // !!! StrictNullCheck Violation
        for (var i = 0; i < value.length; ++i) {
            var char = value.charCodeAt(i);
            if (char < 0x80) {
                array.push(char);
            }
            else if (char < 0x800) {
                array.push(0xc0 | (char >> 6), 0x80 | (char & 0x3f));
            }
            else if (char < 0xd800 || char >= 0xe000) {
                array.push(0xe0 | (char >> 12), 0x80 | ((char >> 6) & 0x3f), 0x80 | (char & 0x3f));
            }
            else {
                char =
                    0x10000 + (((char & 0x3ff) << 10) | (value.charCodeAt(++i) & 0x3ff));
                array.push(0xf0 | (char >> 18), 0x80 | ((char >> 12) & 0x3f), 0x80 | ((char >> 6) & 0x3f), 0x80 | (char & 0x3f));
            }
        }
        return array;
    };
    return Utf8;
}());

var Base64 = /** @class */ (function () {
    function Base64() {
    }
    Base64.GetString = function (inArray) {
        var lookup = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var output = []; // !!! StrictNullCheck Violation
        var paddingBytes = inArray.length % 3;
        var i, temp, length;
        var toBase64 = function (num) {
            return [
                lookup.charAt((num >> 18) & 0x3f),
                lookup.charAt((num >> 12) & 0x3f),
                lookup.charAt((num >> 6) & 0x3f),
                lookup.charAt(num & 0x3f)
            ].join("");
        };
        for (i = 0, length = inArray.length - paddingBytes; i < length; i += 3) {
            temp = (inArray[i] << 16) + (inArray[i + 1] << 8) + inArray[i + 2];
            output.push(toBase64(temp));
        }
        switch (paddingBytes) {
            case 1:
                temp = inArray[inArray.length - 1];
                output.push(lookup.charAt(temp >> 2));
                output.push(lookup.charAt((temp << 4) & 0x3f));
                output.push("==");
                break;
            case 2:
                temp = (inArray[inArray.length - 2] << 8) + inArray[inArray.length - 1];
                output.push(lookup.charAt(temp >> 10));
                output.push(lookup.charAt((temp >> 4) & 0x3f));
                output.push(lookup.charAt((temp << 2) & 0x3f));
                output.push("=");
                break;
        }
        return output.join("");
    };
    return Base64;
}());

var Varint = /** @class */ (function () {
    function Varint() {
    }
    Varint.GetBytes = function (value) {
        var array = []; // !!! StrictNullCheck Violation
        while (value & 0xffffff80) {
            array.push((value & 0x7f) | 0x80);
            value >>>= 7;
        }
        array.push(value & 0x7f);
        return array;
    };
    return Varint;
}());

var Varint64 = /** @class */ (function () {
    function Varint64() {
    }
    Varint64.GetBytes = function (value) {
        var low = value.low;
        var high = value.high;
        var array = []; // !!! StrictNullCheck Violation
        while (high || 0xffffff80 & low) {
            array.push((low & 0x7f) | 0x80);
            low = ((high & 0x7f) << 25) | (low >>> 7);
            high >>>= 7;
        }
        array.push(low & 0x7f);
        return array;
    };
    return Varint64;
}());

var Float = /** @class */ (function () {
    function Float() {
    }
    Float.GetBytes = function (value) {
        if (_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* BrowserChecker */ "a"].IsDataViewSupport()) {
            var view = new DataView(new ArrayBuffer(4));
            view.setFloat32(0, value, true /*littleEndian*/);
            var array = []; // !!! StrictNullCheck Violation
            for (var i = 0; i < 4; ++i) {
                array.push(view.getUint8(i));
            }
            return array;
        }
        else {
            return FloatUtils.ConvertNumberToArray(value, false /*isDouble*/);
        }
    };
    return Float;
}());

// Note: see notes of Float.
var Double = /** @class */ (function () {
    function Double() {
    }
    Double.GetBytes = function (value) {
        if (_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* BrowserChecker */ "a"].IsDataViewSupport()) {
            var view = new DataView(new ArrayBuffer(8));
            view.setFloat64(0, value, true /*littleEndian*/);
            var array = []; // !!! StrictNullCheck Violation
            for (var i = 0; i < 8; ++i) {
                array.push(view.getUint8(i));
            }
            return array;
        }
        else {
            return FloatUtils.ConvertNumberToArray(value, true /*isDouble*/);
        }
    };
    return Double;
}());

var Zigzag = /** @class */ (function () {
    function Zigzag() {
    }
    Zigzag.EncodeZigzag16 = function (value) {
        value = _microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* Number */ "e"].ToInt16(value);
        return (value << 1) ^ (value >> (2 /*sizeof(short)*/ * 8 - 1));
    };
    Zigzag.EncodeZigzag32 = function (value) {
        value = _microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* Number */ "e"].ToInt32(value);
        return (value << 1) ^ (value >> (4 /*sizeof(int)*/ * 8 - 1));
    };
    Zigzag.EncodeZigzag64 = function (value) {
        var low = value.low;
        var high = value.high;
        var tmpH = (high << 1) | (low >>> 31);
        var tmpL = low << 1;
        if (high & 0x80000000) {
            tmpH = ~tmpH;
            tmpL = ~tmpL;
        }
        var res = new _microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* UInt64 */ "f"]("0");
        res.low = tmpL;
        res.high = tmpH;
        return res;
    };
    return Zigzag;
}());

var DecodingUtf8 = /** @class */ (function () {
    function DecodingUtf8() {
    }
    DecodingUtf8.GetString = function (data) {
        var res = []; // !!! StrictNullCheck Violation
        for (var i = 0; i < data.length; ++i) {
            var c1 = data[i];
            if (c1 <= 191) {
                res.push(String.fromCharCode(c1));
            }
            else if (c1 <= 223) {
                var c2 = data[++i];
                res.push(String.fromCharCode(((c1 & 31) << 6) | (c2 & 63)));
            }
            else if (c1 <= 239) {
                var c2 = data[++i];
                var c3 = data[++i];
                res.push(String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)));
            }
            else {
                var c2 = data[++i];
                var c3 = data[++i];
                var c4 = data[++i];
                c1 =
                    ((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63);
                c1 -= 0x10000;
                res.push(String.fromCharCode(0xd800 | ((c1 >> 10) & 0x3ff)));
                res.push(String.fromCharCode(0xdc00 | (c1 & 0x3ff)));
            }
        }
        return res.join("");
    };
    return DecodingUtf8;
}());

var DecodingBase64 = /** @class */ (function () {
    function DecodingBase64() {
    }
    DecodingBase64.GetBytes = function (base64Str) {
        var lookup = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var res = []; // !!! StrictNullCheck Violation
        for (var i = 0; i < base64Str.length; ++i) {
            var byte1 = lookup.indexOf(base64Str.charAt(i++));
            var byte2 = lookup.indexOf(base64Str.charAt(i++));
            var byte3 = lookup.indexOf(base64Str.charAt(i++));
            var byte4 = lookup.indexOf(base64Str.charAt(i));
            res.push((byte1 << 2) | (byte2 >> 4));
            if (byte3 >= 0) {
                res.push(((byte2 << 4) & 0xf0) | (byte3 >> 2));
                if (byte4 >= 0) {
                    res.push(((byte3 << 6) & 0xc0) | byte4);
                }
            }
        }
        return res;
    };
    return DecodingBase64;
}());

var DecodingVarint = /** @class */ (function () {
    function DecodingVarint() {
    }
    DecodingVarint.GetInt64 = function (buffer) {
        var int64 = new _microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* Int64 */ "d"]("0");
        var data = this._Read(buffer);
        int64.low = data[0];
        if (data.length > 1) {
            int64.high = data[1];
        }
        return int64;
    };
    DecodingVarint.GetNumber = function (buffer) {
        return this._Read(buffer)[0];
    };
    DecodingVarint._Read = function (buffer) {
        var result = []; // !!! StrictNullCheck Violation
        var tmp = 0;
        var hasMore = true;
        var readedBits = 0;
        // first, lets try to read the first 32 bits
        while (hasMore) {
            var raw = buffer.shift();
            hasMore = (raw & 0x80) != 0;
            raw = raw & 0x7f;
            if (readedBits < 28) {
                tmp |= raw << readedBits;
                readedBits += 7;
            }
            else {
                // only lower 4 bits can be put
                tmp |= raw << readedBits;
                result.push(tmp);
                tmp = raw >> 4;
                readedBits = 3;
                break;
            }
        }
        // then, read the second 32 bits
        while (hasMore) {
            var raw = buffer.shift();
            hasMore = (raw & 0x80) != 0;
            raw = raw & 0x7f;
            tmp |= raw << readedBits;
            readedBits += 7;
            if (readedBits >= 32) {
                break;
            }
        }
        result.push(tmp);
        return result;
    };
    return DecodingVarint;
}());

var DecodingFloat = /** @class */ (function () {
    function DecodingFloat() {
    }
    DecodingFloat.GetNumber = function (buffer) {
        if (_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* BrowserChecker */ "a"].IsDataViewSupport()) {
            var view = new DataView(new ArrayBuffer(4));
            for (var i = 0; i < 4; ++i) {
                view.setUint8(i, buffer[i]);
            }
            return view.getFloat32(0, true /*littleEndian*/);
        }
        else {
            return FloatUtils.ConvertArrayToNumber(buffer, false /*isDouble*/);
        }
    };
    return DecodingFloat;
}());

var DecodingDouble = /** @class */ (function () {
    function DecodingDouble() {
    }
    DecodingDouble.GetNumber = function (buffer) {
        if (_microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* BrowserChecker */ "a"].IsDataViewSupport()) {
            var view = new DataView(new ArrayBuffer(8));
            for (var i = 0; i < 8; ++i) {
                view.setUint8(i, buffer[i]);
            }
            return view.getFloat64(0, true /*littleEndian*/);
        }
        else {
            return FloatUtils.ConvertArrayToNumber(buffer, true /*isDouble*/);
        }
    };
    return DecodingDouble;
}());

var DecodingZigzag = /** @class */ (function () {
    function DecodingZigzag() {
    }
    DecodingZigzag.DecodeZigzag16 = function (value) {
        return ((((0xffff & value) >>> 1) ^ -(value & 1)) << 16) >> 16;
    };
    DecodingZigzag.DecodeZigzag32 = function (value) {
        return (value >>> 1) ^ -(value & 1);
    };
    DecodingZigzag.DecodeZigzag64 = function (value) {
        // implement
        // (value >>> 1) ^ (-(value & 1))
        var tmpH = value.high & 1;
        var high = value.high >>> 1;
        var tmpL = value.low & 1;
        var low = value.low >>> 1;
        low = (tmpH << 31) | low;
        if (tmpL) {
            low ^= 0xffffffff;
            high ^= 0xffffffff;
        }
        var res = new _microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* UInt64 */ "f"]("0");
        res.low = low;
        res.high = high;
        return res;
    };
    return DecodingZigzag;
}());

/** This class will be used to convert float/double to byte array on browsers which doesn't
        support html5.

        Format: IEEE-754, littleEndian, http://en.wikipedia.org/wiki/IEEE_754-1985

        \note
        1. Don't have negative zero. All zero will be positive zero.
        2. If the buffer array passed to ConvertArrayToFloat() is actual NaN or Inifinity value,
            exception will be raised.
    */
var FloatUtils = /** @class */ (function () {
    function FloatUtils() {
    }
    FloatUtils.ConvertNumberToArray = function (num, isDouble) {
        if (!num) {
            return isDouble ? this._doubleZero : this._floatZero;
        }
        var exponentBits = isDouble ? 11 : 8;
        var precisionBits = isDouble ? 52 : 23;
        // follow IEEE-754, exponent bias is 2^(k-1)-1 where k is the number of bits
        // in the exponent: http://en.wikipedia.org/wiki/Exponent_bias
        var bias = (1 << (exponentBits - 1)) - 1;
        var minExponent = 1 - bias;
        var maxExponent = bias;
        var sign = num < 0 ? 1 : 0;
        num = Math.abs(num);
        var intPart = Math.floor(num);
        var floatPart = num - intPart;
        var len = 2 * (bias + 2) + precisionBits;
        var buffer = new Array(len);
        var i = 0;
        while (i < len) {
            buffer[i++] = 0;
        }
        // caculate the intPart
        i = bias + 2;
        while (i && intPart) {
            buffer[--i] = intPart % 2;
            intPart = Math.floor(intPart / 2);
        }
        // caculate the floatPart
        i = bias + 1;
        while (i < len - 1 && floatPart > 0) {
            floatPart *= 2;
            if (floatPart >= 1) {
                buffer[++i] = 1;
                --floatPart;
            }
            else {
                buffer[++i] = 0;
            }
        }
        // find the first 1
        var firstBit = 0;
        for (; firstBit < len && !buffer[firstBit]; ++firstBit)
            ;
        // caculate exponent
        var exponent = bias + 1 - firstBit;
        // caculate round
        var lastBit = firstBit + precisionBits;
        if (buffer[lastBit + 1]) {
            for (i = lastBit; i > firstBit; --i) {
                if ((buffer[i] = 1 - buffer[i])) {
                    break;
                }
            }
            if (i == firstBit) {
                ++exponent;
            }
        }
        // check overflow
        if (exponent > maxExponent || intPart) {
            if (sign) {
                return isDouble ? this._doubleNegInifinity : this._floatNegInifinity;
            }
            else {
                return isDouble ? this._doubleInifinity : this._floatInifinity;
            }
        }
        else if (exponent < minExponent) {
            return isDouble ? this._doubleZero : this._floatZero;
        }
        // caculate the result
        if (isDouble) {
            var high = 0;
            for (i = 0; i < 20; ++i) {
                high = (high << 1) | buffer[++firstBit];
            }
            var low = 0;
            for (; i < 52; ++i) {
                low = (low << 1) | buffer[++firstBit];
            }
            high |= (exponent + bias) << 20;
            high = (sign << 31) | (high & 0x7fffffff);
            var resArray = [
                low & 0xff,
                (low >> 8) & 0xff,
                (low >> 16) & 0xff,
                low >>> 24,
                high & 0xff,
                (high >> 8) & 0xff,
                (high >> 16) & 0xff,
                high >>> 24
            ];
            return resArray;
        }
        else {
            var result = 0;
            for (i = 0; i < 23; ++i) {
                result = (result << 1) | buffer[++firstBit];
            }
            result |= (exponent + bias) << 23;
            result = (sign << 31) | (result & 0x7fffffff);
            var resArray = [
                result & 0xff,
                (result >> 8) & 0xff,
                (result >> 16) & 0xff,
                result >>> 24
            ];
            return resArray;
        }
    };
    FloatUtils.ConvertArrayToNumber = function (buffer, isDouble) {
        var exponentBits = isDouble ? 11 : 8;
        var bias = (1 << (exponentBits - 1)) - 1;
        var sign = (buffer[isDouble ? 7 : 3] & 0x80) != 0;
        var exponent = isDouble
            ? ((buffer[7] & 0x7f) << 4) | ((buffer[6] & 0xf0) >> 4)
            : ((buffer[3] & 0x7f) << 1) | ((buffer[2] & 0x80) >> 7);
        // check the buffer is valid or not. If it is invalid (NaN, Infinitive), throw execption.
        if (exponent == 0xff) {
            throw new _microsoft_bond__WEBPACK_IMPORTED_MODULE_0__[/* Exception */ "c"]("Not a valid float/double buffer.");
        }
        var res = 1;
        var e = 1;
        if (isDouble) {
            var high = ((buffer[6] & 0xf) << 28) |
                ((buffer[5] & 0xff) << 20) |
                ((buffer[4] & 0xff) << 12);
            var low = (buffer[3] << 24) |
                ((buffer[2] & 0xff) << 16) |
                ((buffer[1] & 0xff) << 8) |
                (buffer[0] & 0xff);
            if (!exponent && !high && !low) {
                return 0.0;
            }
            for (var i = 0; i < 20; ++i) {
                e /= 2;
                if (high < 0) {
                    res += e;
                }
                high <<= 1;
            }
            for (var i = 0; i < 32; ++i) {
                e /= 2;
                if (low < 0) {
                    res += e;
                }
                low <<= 1;
            }
        }
        else {
            var data = ((buffer[2] & 0x7f) << 25) |
                ((buffer[1] & 0xff) << 17) |
                ((buffer[0] & 0xff) << 9);
            if (!exponent && !data) {
                return 0.0;
            }
            for (var i = 0; i < 23; ++i) {
                e /= 2;
                if (data < 0) {
                    res += e;
                }
                data <<= 1;
            }
        }
        res *= Math.pow(2, exponent - bias);
        return sign ? 0 - res : res;
    };
    FloatUtils._floatZero = [0x00, 0x00, 0x00, 0x00];
    FloatUtils._doubleZero = [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00];
    FloatUtils._floatInifinity = [0x00, 0x00, 0x80, 0x7f];
    FloatUtils._floatNegInifinity = [0x00, 0x00, 0x80, 0xff];
    FloatUtils._doubleInifinity = [
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0xf0,
        0x7f
    ];
    FloatUtils._doubleNegInifinity = [
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0xf0,
        0xff
    ];
    return FloatUtils;
}());


/***/ }),

/***/ "1fe0d4d94639de12e325":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Set */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Map; });
// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115
var Set = /** @class */ (function () {
    function Set() {
        this._buffer = [];
    }
    Set.prototype.Add = function (t) {
        var i = 0;
        for (; i < this._buffer.length; ++i) {
            if (this._buffer[i] == t) {
                break;
            }
        }
        if (i == this._buffer.length) {
            this._buffer.push(t);
        }
    };
    Set.prototype.Count = function () {
        return this._buffer.length;
    };
    Set.prototype.GetBuffer = function () {
        return this._buffer;
    };
    return Set;
}());

// Modified bond code to add AddorReplace and Remove for Map
//TODO(abpanwar): Contact the bond team to add this to their library.
var Map = /** @class */ (function () {
    function Map() {
        this._buffer = [];
    }
    Map.prototype.Add = function (key, value) {
        if (this._getIndex(key) == -1) {
            this._buffer.push({ Key: key, Value: value });
        }
    };
    Map.prototype.AddOrReplace = function (key, value) {
        var i = this._getIndex(key);
        if (i >= 0) {
            this._buffer[i] = { Key: key, Value: value };
        }
        else {
            this._buffer.push({ Key: key, Value: value });
        }
    };
    Map.prototype.Remove = function (key) {
        var i = this._getIndex(key);
        if (i >= 0) {
            this._buffer.splice(i, 1);
        }
    };
    Map.prototype.Count = function () {
        return this._buffer.length;
    };
    Map.prototype.GetBuffer = function () {
        return this._buffer;
    };
    Map.prototype.ContainsKey = function (key) {
        if (this._getIndex(key) >= 0) {
            return true;
        }
        return false;
    };
    Map.prototype.Get = function (key) {
        var i = this._getIndex(key);
        if (i >= 0) {
            return this._buffer[i].Value;
        }
        return null;
    };
    Map.prototype._getIndex = function (key) {
        var i = 0;
        var index = -1;
        for (; i < this._buffer.length; ++i) {
            if (this._buffer[i].Key == key) {
                index = i;
                break;
            }
        }
        return index;
    };
    return Map;
}());



/***/ }),

/***/ "3a999a77208bb0077152":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return darkPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contrastPalette; });
var defaultPalette = {
    themePrimary: "#6264a7",
    themeLighterAlt: "#f4f4f9",
    themeLighter: "#e3e3ef",
    themeLight: "#babbd8",
    themeTertiary: "#898bbc",
    themeSecondary: "#696baa",
    themeDarkAlt: "rgba(37, 36, 36, 0.75);",
    themeDark: "#3d3f6c",
    themeDarker: "#34365c",
    neutralLighterAlt: "#f8f8f8",
    neutralLighter: "#f3f2f1",
    neutralLight: "#ffffff",
    neutralQuaternaryAlt: "#fcfcfb",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c8c8",
    neutralTertiary: "#b6b4b4",
    neutralSecondary: "#9f9c9c",
    neutralPrimaryAlt: "#878383",
    neutralPrimary: "#252424",
    neutralDark: "#575454",
    black: "#3f3d3d",
    white: "#f9f8f7",
    primaryBackground: "#f9f8f7",
    primaryText: "rgba(37, 36, 36, 0.75);",
    bodyBackground: "#f9f8f7",
    bodyText: "rgba(37, 36, 36, 0.75);",
    disabledBackground: "#f4f4f4",
    disabledText: "#c8c8c8",
    boxShadowColor: "rgba(0, 0, 0, .5);",
    appGray02: "rgba(37, 36, 36, 0.75);",
    appGray04: "#979593",
    appGray06: "rgba(37, 36, 36, 0.3);",
    appGray10: "#f3f2f1",
    appWhite: "#fff",
    appBlackFull: "#000"
};
var darkPalette = {
    themePrimary: "#6264a7",
    themeLighterAlt: "#07070c",
    themeLighter: "#11121e",
    themeLight: "#2a2b49",
    themeTertiary: "#48497e",
    themeSecondary: "#5b5ea1",
    themeDarkAlt: "#7274af",
    themeDark: "#9a9cc6",
    themeDarker: "#a9aace",
    neutralLighterAlt: "#373636",
    neutralLighter: "#313030",
    neutralLight: "#201f1f",
    neutralQuaternaryAlt: "#1e1d1d",
    neutralQuaternary: "#5c5a5a",
    neutralTertiaryAlt: "#787575",
    neutralTertiary: "#c8c8c8",
    neutralSecondary: "#d0d0d0",
    neutralPrimaryAlt: "#dadada",
    neutralPrimary: "#ffffff",
    neutralDark: "#f4f4f4",
    black: "#f8f8f8",
    white: "#2d2c2c",
    primaryBackground: "#2d2c2c",
    primaryText: "#fff",
    bodyBackground: "#2d2c2c",
    bodyText: "#fff",
    disabledBackground: "#2c2b2b",
    disabledText: "#242323",
    boxShadowColor: "rgba(0, 0, 0, .5);",
    appGray02: "rgba(255, 255, 255, .75);",
    appGray04: "#979593",
    appGray06: "rgba(255, 255, 255, 0.3);",
    appGray10: "#2d2c2c",
    appWhite: "#fff",
    appBlackFull: "#000" // $app-black-full
};
var contrastPalette = {
    themePrimary: "#ffff01",
    themeLighterAlt: "#121200",
    themeLighter: "#2e2e00",
    themeLight: "#6f6f00",
    themeTertiary: "#c0c000",
    themeSecondary: "#f4f400",
    themeDarkAlt: "#ffff19",
    themeDark: "#ffff5c",
    themeDarker: "#ffff73",
    neutralLighterAlt: "#0b0b0b",
    neutralLighter: "#151515",
    neutralLight: "#252525",
    neutralQuaternaryAlt: "#2f2f2f",
    neutralQuaternary: "#373737",
    neutralTertiaryAlt: "#595959",
    neutralTertiary: "#c8c8c8",
    neutralSecondary: "#d0d0d0",
    neutralPrimaryAlt: "#dadada",
    neutralPrimary: "#fff",
    neutralDark: "#f4f4f4",
    black: "#f8f8f8",
    white: "#000",
    primaryBackground: "#000",
    primaryText: "#fff",
    bodyBackground: "#000",
    bodyText: "#fff",
    disabledBackground: "#NaNNaNNaN",
    disabledText: "#NaNNaNNaN",
    boxShadowColor: "rgba(0, 0, 0, .5);",
    appGray02: "#fff",
    appGray04: "#979593",
    appGray06: "#000",
    appGray10: "#000",
    appWhite: "#fff",
    appBlackFull: "#000" // app-black-full
};


/***/ }),

/***/ "69ef09bc7fd3484310a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldTag */
/* unused harmony export ContainerTag */
/* unused harmony export KeyValueContainerTag */
/* unused harmony export Bonded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Int64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UInt64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Exception; });
/* unused harmony export KeyValuePair */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserChecker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CompactBinaryProtocolWriter; });
/* unused harmony export CompactBinaryProtocolReader */
/* harmony import */ var _bond_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e3f1ab2f47504a835c5c");
/* harmony import */ var _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("12750d13a8e05f549bfb");
// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115

// OOO Circular: services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.ts > services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.encoding.ts

var FieldTag = /** @class */ (function () {
    function FieldTag(type, id) {
        this.Type = type;
        this.Id = id;
    }
    return FieldTag;
}());

var ContainerTag = /** @class */ (function () {
    function ContainerTag(elementType, size) {
        this.ElementType = elementType;
        this.Size = size;
    }
    return ContainerTag;
}());

var KeyValueContainerTag = /** @class */ (function () {
    function KeyValueContainerTag(keyType, valueType, size) {
        this.KeyType = keyType;
        this.ValueType = valueType;
        this.Size = size;
    }
    return KeyValueContainerTag;
}());

// @ts-ignore
var Bonded = /** @class */ (function () {
    function Bonded() {
    }
    return Bonded;
}());

var Int64 = /** @class */ (function () {
    // BUG!!: need implement, currently, just handle 32bits number
    function Int64(numberStr) {
        this.low = 0;
        this.high = 0;
        this.low = parseInt(numberStr);
        if (this.low < 0) {
            this.high = -1;
        }
    }
    Int64.prototype.Equals = function (numberStr) {
        var tmp = new Int64(numberStr);
        return this.low == tmp.low && this.high == tmp.high;
    };
    return Int64;
}());

var UInt64 = /** @class */ (function () {
    // BUG!!: need implement, currently, just handle 32bits number
    function UInt64(numberStr) {
        this.low = 0;
        this.high = 0;
        this.low = parseInt(numberStr);
    }
    UInt64.prototype.Equals = function (numberStr) {
        var tmp = new UInt64(numberStr);
        return this.low == tmp.low && this.high == tmp.high;
    };
    return UInt64;
}());

var Number = /** @class */ (function () {
    function Number() {
    }
    Number.ToByte = function (value) {
        return this.ToUInt8(value);
    };
    Number.ToInt8 = function (value) {
        var signMask = ((value & 0x80) << 24) >> 24;
        return (value & 0x7f) | signMask;
    };
    Number.ToInt16 = function (value) {
        var signMask = ((value & 0x8000) << 16) >> 16;
        return (value & 0x7fff) | signMask;
    };
    Number.ToInt32 = function (value) {
        var signMask = value & 0x80000000;
        return (value & 0x7fffffff) | signMask;
    };
    Number.ToUInt8 = function (value) {
        return value & 0xff;
    };
    Number.ToUInt16 = function (value) {
        return value & 0xffff;
    };
    Number.ToUInt32 = function (value) {
        return value & 0xffffffff;
    };
    return Number;
}());

var Exception = /** @class */ (function () {
    function Exception(message) {
        this.Message = message;
    }
    return Exception;
}());

var KeyValuePair = /** @class */ (function () {
    function KeyValuePair() {
    }
    return KeyValuePair;
}());

var BrowserChecker = /** @class */ (function () {
    function BrowserChecker() {
    }
    BrowserChecker.IsDataViewSupport = function () {
        return typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
    };
    return BrowserChecker;
}());

var CompactBinaryProtocolWriter = /** @class */ (function () {
    function CompactBinaryProtocolWriter(stream) {
        this._stream = stream;
    }
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteBlob = function (blob) {
        this._stream.Write(blob, 0, blob.length);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteBool = function (value) {
        this._stream.WriteByte(value ? 1 : 0);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteContainerBegin = function (size, elementType) {
        this.WriteUInt8(elementType);
        this.WriteUInt32(size);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteMapContainerBegin = function (size, keyType, valueType) {
        this.WriteUInt8(keyType);
        this.WriteUInt8(valueType);
        this.WriteUInt32(size);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteContainerEnd = function () { };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteDouble = function (value) {
        var array = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Double */ "b"].GetBytes(value);
        this._stream.Write(array, 0, array.length);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteFloat = function (value) {
        var array = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Float */ "c"].GetBytes(value);
        this._stream.Write(array, 0, array.length);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteFieldBegin = function (type, id, 
    // @ts-ignore
    metadata) {
        if (id <= 5) {
            this._stream.WriteByte(type | (id << 5));
        }
        else if (id <= 0xff) {
            this._stream.WriteByte(type | (6 << 5));
            this._stream.WriteByte(id);
        }
        else {
            this._stream.WriteByte(type | (7 << 5));
            this._stream.WriteByte(id);
            this._stream.WriteByte(id >> 8);
        }
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteFieldEnd = function () { };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteFieldOmitted = function (
    // @ts-ignore
    type, 
    // @ts-ignore
    id, 
    // @ts-ignore
    metadata) { };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteInt16 = function (value) {
        value = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Zigzag */ "g"].EncodeZigzag16(value);
        this.WriteUInt16(value);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteInt32 = function (value) {
        value = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Zigzag */ "g"].EncodeZigzag32(value);
        this.WriteUInt32(value);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteInt64 = function (value) {
        this.WriteUInt64(_microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Zigzag */ "g"].EncodeZigzag64(value));
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteInt8 = function (value) {
        this._stream.WriteByte(Number.ToInt8(value));
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteString = function (value) {
        if (value == "") {
            this.WriteUInt32(0 /*length*/);
        }
        else {
            var array = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Utf8 */ "d"].GetBytes(value);
            this.WriteUInt32(array.length);
            this._stream.Write(array, 0, array.length);
        }
    };
    /*override*/
    // @ts-ignore
    CompactBinaryProtocolWriter.prototype.WriteStructBegin = function (metadata, isBase) { };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteStructEnd = function (isBase) {
        this.WriteUInt8(isBase ? _bond_const__WEBPACK_IMPORTED_MODULE_0__[/* BondDataType */ "a"].BT_STOP_BASE : _bond_const__WEBPACK_IMPORTED_MODULE_0__[/* BondDataType */ "a"].BT_STOP);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteUInt16 = function (value) {
        var array = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Varint */ "e"].GetBytes(Number.ToUInt16(value));
        this._stream.Write(array, 0, array.length);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteUInt32 = function (value) {
        var array = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Varint */ "e"].GetBytes(Number.ToUInt32(value));
        this._stream.Write(array, 0, array.length);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteUInt64 = function (value) {
        var array = _microsoft_bond_encoding__WEBPACK_IMPORTED_MODULE_1__[/* Varint64 */ "f"].GetBytes(value);
        this._stream.Write(array, 0, array.length);
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteUInt8 = function (value) {
        this._stream.WriteByte(Number.ToUInt8(value));
    };
    /*override*/
    CompactBinaryProtocolWriter.prototype.WriteWString = function (value) {
        this.WriteUInt32(value.length);
        for (var i = 0; i < value.length; ++i) {
            var charCode = value.charCodeAt(i);
            this._stream.WriteByte(charCode);
            this._stream.WriteByte(charCode >>> 8);
        }
    };
    return CompactBinaryProtocolWriter;
}());

var CompactBinaryProtocolReader = /** @class */ (function () {
    function CompactBinaryProtocolReader() {
    }
    return CompactBinaryProtocolReader;
}());



/***/ }),

/***/ "a7da6f9b6f83baa39297":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unknownExtension; });
/* unused harmony export KnownExtension */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isKnownExtension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getKnownFileExtensionsList; });
var unknownExtension = "other";
/**
 * This list supports uppercase as well for all of these extension types
 */
var KnownExtension;
(function (KnownExtension) {
    KnownExtension[KnownExtension["7z"] = 0] = "7z";
    KnownExtension[KnownExtension["folder"] = 1] = "folder";
    KnownExtension[KnownExtension["directory"] = 2] = "directory";
    KnownExtension[KnownExtension["accdb"] = 3] = "accdb";
    KnownExtension[KnownExtension["ai"] = 4] = "ai";
    KnownExtension[KnownExtension["apk"] = 5] = "apk";
    KnownExtension[KnownExtension["aspx"] = 6] = "aspx";
    KnownExtension[KnownExtension["avi"] = 7] = "avi";
    KnownExtension[KnownExtension["bat"] = 8] = "bat";
    KnownExtension[KnownExtension["bmp"] = 9] = "bmp";
    KnownExtension[KnownExtension["carpeta"] = 10] = "carpeta";
    KnownExtension[KnownExtension["cell"] = 11] = "cell";
    KnownExtension[KnownExtension["config"] = 12] = "config";
    KnownExtension[KnownExtension["cs"] = 13] = "cs";
    KnownExtension[KnownExtension["css"] = 14] = "css";
    KnownExtension[KnownExtension["csv"] = 15] = "csv";
    KnownExtension[KnownExtension["db"] = 16] = "db";
    KnownExtension[KnownExtension["dll"] = 17] = "dll";
    KnownExtension[KnownExtension["doc"] = 18] = "doc";
    KnownExtension[KnownExtension["docm"] = 19] = "docm";
    KnownExtension[KnownExtension["docx"] = 20] = "docx";
    KnownExtension[KnownExtension["dossier"] = 21] = "dossier";
    KnownExtension[KnownExtension["dotx"] = 22] = "dotx";
    KnownExtension[KnownExtension["eml"] = 23] = "eml";
    KnownExtension[KnownExtension["eps"] = 24] = "eps";
    KnownExtension[KnownExtension["exe"] = 25] = "exe";
    KnownExtension[KnownExtension["gif"] = 26] = "gif";
    KnownExtension[KnownExtension["gz"] = 27] = "gz";
    KnownExtension[KnownExtension["htm"] = 28] = "htm";
    KnownExtension[KnownExtension["html"] = 29] = "html";
    KnownExtension[KnownExtension["hwp"] = 30] = "hwp";
    KnownExtension[KnownExtension["indd"] = 31] = "indd";
    KnownExtension[KnownExtension["jar"] = 32] = "jar";
    KnownExtension[KnownExtension["java"] = 33] = "java";
    KnownExtension[KnownExtension["jpeg"] = 34] = "jpeg";
    KnownExtension[KnownExtension["jpg"] = 35] = "jpg";
    KnownExtension[KnownExtension["js"] = 36] = "js";
    KnownExtension[KnownExtension["json"] = 37] = "json";
    KnownExtension[KnownExtension["kansio"] = 38] = "kansio";
    KnownExtension[KnownExtension["key"] = 39] = "key";
    KnownExtension[KnownExtension["lnk"] = 40] = "lnk";
    KnownExtension[KnownExtension["log"] = 41] = "log";
    KnownExtension[KnownExtension["m4a"] = 42] = "m4a";
    KnownExtension[KnownExtension["map"] = 43] = "map";
    KnownExtension[KnownExtension["mapp"] = 44] = "mapp";
    KnownExtension[KnownExtension["mappe"] = 45] = "mappe";
    KnownExtension[KnownExtension["md"] = 46] = "md";
    KnownExtension[KnownExtension["mht"] = 47] = "mht";
    KnownExtension[KnownExtension["mov"] = 48] = "mov";
    KnownExtension[KnownExtension["mp3"] = 49] = "mp3";
    KnownExtension[KnownExtension["mp4"] = 50] = "mp4";
    KnownExtension[KnownExtension["mpp"] = 51] = "mpp";
    KnownExtension[KnownExtension["msg"] = 52] = "msg";
    KnownExtension[KnownExtension["msi"] = 53] = "msi";
    KnownExtension[KnownExtension["odp"] = 54] = "odp";
    KnownExtension[KnownExtension["ods"] = 55] = "ods";
    KnownExtension[KnownExtension["odt"] = 56] = "odt";
    KnownExtension[KnownExtension["oft"] = 57] = "oft";
    KnownExtension[KnownExtension["one"] = 58] = "one";
    KnownExtension[KnownExtension["onepkg"] = 59] = "onepkg";
    KnownExtension[KnownExtension["ordner"] = 60] = "ordner";
    KnownExtension[KnownExtension["pages"] = 61] = "pages";
    KnownExtension[KnownExtension["pasta"] = 62] = "pasta";
    KnownExtension[KnownExtension["pbix"] = 63] = "pbix";
    KnownExtension[KnownExtension["pdf"] = 64] = "pdf";
    KnownExtension[KnownExtension["php"] = 65] = "php";
    KnownExtension[KnownExtension["phz"] = 66] = "phz";
    KnownExtension[KnownExtension["png"] = 67] = "png";
    KnownExtension[KnownExtension["potm"] = 68] = "potm";
    KnownExtension[KnownExtension["potx"] = 69] = "potx";
    KnownExtension[KnownExtension["ppsx"] = 70] = "ppsx";
    KnownExtension[KnownExtension["ppt"] = 71] = "ppt";
    KnownExtension[KnownExtension["pptm"] = 72] = "pptm";
    KnownExtension[KnownExtension["pptx"] = 73] = "pptx";
    KnownExtension[KnownExtension["ps1"] = 74] = "ps1";
    KnownExtension[KnownExtension["psd"] = 75] = "psd";
    KnownExtension[KnownExtension["pub"] = 76] = "pub";
    KnownExtension[KnownExtension["py"] = 77] = "py";
    KnownExtension[KnownExtension["rar"] = 78] = "rar";
    KnownExtension[KnownExtension["rtf"] = 79] = "rtf";
    KnownExtension[KnownExtension["show"] = 80] = "show";
    KnownExtension[KnownExtension["sketch"] = 81] = "sketch";
    KnownExtension[KnownExtension["sldprt"] = 82] = "sldprt";
    KnownExtension[KnownExtension["sql"] = 83] = "sql";
    KnownExtension[KnownExtension["svg"] = 84] = "svg";
    KnownExtension[KnownExtension["tif"] = 85] = "tif";
    KnownExtension[KnownExtension["twbx"] = 86] = "twbx";
    KnownExtension[KnownExtension["txt"] = 87] = "txt";
    KnownExtension[KnownExtension["url"] = 88] = "url";
    KnownExtension[KnownExtension["vsd"] = 89] = "vsd";
    KnownExtension[KnownExtension["vsdx"] = 90] = "vsdx";
    KnownExtension[KnownExtension["wav"] = 91] = "wav";
    KnownExtension[KnownExtension["wma"] = 92] = "wma";
    KnownExtension[KnownExtension["wmv"] = 93] = "wmv";
    KnownExtension[KnownExtension["xls"] = 94] = "xls";
    KnownExtension[KnownExtension["xlsb"] = 95] = "xlsb";
    KnownExtension[KnownExtension["xlsm"] = 96] = "xlsm";
    KnownExtension[KnownExtension["xlsx"] = 97] = "xlsx";
    KnownExtension[KnownExtension["xltx"] = 98] = "xltx";
    KnownExtension[KnownExtension["xmind"] = 99] = "xmind";
    KnownExtension[KnownExtension["xml"] = 100] = "xml";
    KnownExtension[KnownExtension["zip"] = 101] = "zip";
})(KnownExtension || (KnownExtension = {}));
function isKnownExtension(ext) {
    return !!KnownExtension[ext];
}
/**
 * This function lookup for known predefined file type extensions, which are stored as enum,
 * converts them in list of strings & returns that.
 */
function getKnownFileExtensionsList() {
    return Object.keys(KnownExtension).filter(function (x) {
        return isNaN(Number(x));
    });
}


/***/ }),

/***/ "e3f1ab2f47504a835c5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BondDataType; });
/* unused harmony export ProtocolType */
// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Tool     : bondc, Version=3.0.1, Build=bond-git.debug.not
//     Template : Microsoft.Bond.Rules.dll#TypeScript.tt
//     File     : bond-const.ts
//
//     Changes to this file may cause incorrect behavior and will be lost when
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
var BondDataType;
(function (BondDataType) {
    BondDataType[BondDataType["BT_STOP"] = 0] = "BT_STOP";
    BondDataType[BondDataType["BT_STOP_BASE"] = 1] = "BT_STOP_BASE";
    BondDataType[BondDataType["BT_BOOL"] = 2] = "BT_BOOL";
    BondDataType[BondDataType["BT_UINT8"] = 3] = "BT_UINT8";
    BondDataType[BondDataType["BT_UINT16"] = 4] = "BT_UINT16";
    BondDataType[BondDataType["BT_UINT32"] = 5] = "BT_UINT32";
    BondDataType[BondDataType["BT_UINT64"] = 6] = "BT_UINT64";
    BondDataType[BondDataType["BT_FLOAT"] = 7] = "BT_FLOAT";
    BondDataType[BondDataType["BT_DOUBLE"] = 8] = "BT_DOUBLE";
    BondDataType[BondDataType["BT_STRING"] = 9] = "BT_STRING";
    BondDataType[BondDataType["BT_STRUCT"] = 10] = "BT_STRUCT";
    BondDataType[BondDataType["BT_LIST"] = 11] = "BT_LIST";
    BondDataType[BondDataType["BT_SET"] = 12] = "BT_SET";
    BondDataType[BondDataType["BT_MAP"] = 13] = "BT_MAP";
    BondDataType[BondDataType["BT_INT8"] = 14] = "BT_INT8";
    BondDataType[BondDataType["BT_INT16"] = 15] = "BT_INT16";
    BondDataType[BondDataType["BT_INT32"] = 16] = "BT_INT32";
    BondDataType[BondDataType["BT_INT64"] = 17] = "BT_INT64";
    BondDataType[BondDataType["BT_WSTRING"] = 18] = "BT_WSTRING";
    BondDataType[BondDataType["BT_UNAVAILABLE"] = 127] = "BT_UNAVAILABLE";
})(BondDataType || (BondDataType = {}));
var ProtocolType;
(function (ProtocolType) {
    ProtocolType[ProtocolType["MARSHALED_PROTOCOL"] = 0] = "MARSHALED_PROTOCOL";
    ProtocolType[ProtocolType["MAFIA_PROTOCOL"] = 17997] = "MAFIA_PROTOCOL";
    ProtocolType[ProtocolType["COMPACT_PROTOCOL"] = 16963] = "COMPACT_PROTOCOL";
    ProtocolType[ProtocolType["JSON_PROTOCOL"] = 21322] = "JSON_PROTOCOL";
    ProtocolType[ProtocolType["PRETTY_JSON_PROTOCOL"] = 20554] = "PRETTY_JSON_PROTOCOL";
    ProtocolType[ProtocolType["SIMPLE_PROTOCOL"] = 20563] = "SIMPLE_PROTOCOL";
})(ProtocolType || (ProtocolType = {}));


/***/ }),

/***/ "e4015b2ea28f962ed7da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScenarioName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StepName; });
var ScenarioName;
(function (ScenarioName) {
    // Life cycle
    ScenarioName["AppStart"] = "app_start";
    ScenarioName["CoreInitialize"] = "core_initialize";
    ScenarioName["DownloadAndParse"] = "download_and_parse";
    ScenarioName["ResolveMainImports"] = "resolve_main_imports";
    ScenarioName["DomLoadingStart"] = "dom_loading_start";
    ScenarioName["RestorePersistedWindows"] = "restore_persisted_windows";
    ScenarioName["WindowLaunchTime"] = "window_launch_time";
    ScenarioName["DynamicImport"] = "dynamic_import";
    // Actions
    ScenarioName["AcquireToken"] = "acquire_token";
    ScenarioName["AcquireTokenInBackground"] = "acquire_token_in_background";
    ScenarioName["AppCtxProviderWait"] = "app_ctx_provider_wait";
    ScenarioName["CentralDataLayerSubscription"] = "cdl_subscription_agg";
    ScenarioName["CentralDataLayeRequest"] = "cdl_request";
    ScenarioName["CentralDataLayerWorkerStartup"] = "cdl_worker_startup";
    ScenarioName["CentralDataLayerWorkerManagerStartup"] = "cdl_worker_manager_startup";
    ScenarioName["ComposeDisabled"] = "compose_disabled";
    ScenarioName["ChatSendMessage"] = "chat_send_message";
    ScenarioName["GetAuthUser"] = "get_auth_user";
    ScenarioName["GetSkypeToken"] = "get_skype_token";
    ScenarioName["IndexedDBFetch"] = "indexed_db_fetch";
    ScenarioName["LongPollRecovery"] = "long_poll_recovery";
    ScenarioName["LongPollError"] = "long_poll_error";
    ScenarioName["QueryExecution"] = "query_exec";
    ScenarioName["SubscriptionCloseExecution"] = "subscription_close_exec";
    ScenarioName["SubscriptionOpenExecution"] = "subscription_open_exec";
    ScenarioName["FatalError"] = "fatal_error";
    ScenarioName["GlobalWindowError"] = "global_window_error";
    ScenarioName["UnhandledRejection"] = "unhandled_rejection";
    ScenarioName["GarbageCollection"] = "garbage_collection";
    ScenarioName["AuthHandlerRequest"] = "auth_handler_request";
    // Rendering
    ScenarioName["RenderChatList"] = "render_chat_list";
    ScenarioName["RenderComposeChat"] = "render_compose_chat";
    ScenarioName["RenderCallingDefault"] = "render_calling_default";
    ScenarioName["RenderCallsTab"] = "render_calls_tab";
    ScenarioName["RenderCallingJoin"] = "render_calling_join";
    ScenarioName["RenderCallingScreenManager"] = "render_calling_screen_manager";
    ScenarioName["RenderCallingPreJoin"] = "render_calling_prejoin";
    ScenarioName["RenderCallingScreen"] = "render_calling_screen";
    // i18n
    ScenarioName["I18nMissingInterpolationHandler"] = "i18n_missing_interpolation_handler";
    ScenarioName["I18nMissingKeyHandler"] = "i18n_missing_key_handler";
    ScenarioName["I18nNamespaceLoad"] = "i18n_namespace_load";
    ScenarioName["I18nGetLocaleInfo"] = "i18n_get_locale_info";
    // File
    ScenarioName["RenderFileViewer"] = "render_file_viewer";
    ScenarioName["RenderFileEmailViewer"] = "render_file_email_viewer";
    ScenarioName["MainImportToDomContentLoaded"] = "main_import_to_dom_content_loaded";
    ScenarioName["FilePreviewLayoutToJsApiScriptLoad"] = "file_preview_layout_to_jsapi_script_load";
    ScenarioName["JsApiScriptLoad"] = "jsapi_script_load";
    ScenarioName["JsApiFirstStep"] = "jsapi_first_step";
    ScenarioName["JsApiSecondStep"] = "jsapi_second_step";
    ScenarioName["FileRedeem"] = "documents_file_redeem";
    // Chat List Filtering
    ScenarioName["ChatListFiltering"] = "chat_list_filtering";
    // Send Feedback
    ScenarioName["SendFeedback"] = "send_feedback";
    // Personal site info
    ScenarioName["FetchPersonalSiteInfo"] = "fetch-personal-site-info";
    // Create File chiclet on link paste
    ScenarioName["CreateFileChiclet"] = "documents_create_file_chiclet_on_link_paste";
    // FilesPersonalPicker
    ScenarioName["RenderFilesPersonalPicker"] = "render_files_personal_picker";
    ScenarioName["FilesPersonalPicker"] = "files_personal_picker";
    // File Upload
    ScenarioName["FileUploadChatPicker"] = "documents_upload_file_chat_file_picker";
    ScenarioName["FileUploadChatConflict"] = "documents_upload_file_chat_conflict_dialog";
    ScenarioName["FileUploadChatDragNDrop"] = "documents_upload_file_chat_drag_and_drop";
    ScenarioName["FileRemovalChat"] = "documents_remove_file_chat";
    ScenarioName["FileAttachChat"] = "documents_attach_file_chat";
    ScenarioName["FileUploadMeetingPicker"] = "documents_upload_file_meeting_file_picker";
    ScenarioName["FileUploadMeetingConflict"] = "documents_upload_file_meeting_conflict_dialog";
    ScenarioName["FileUploadMeetingDragNDrop"] = "documents_upload_file_meeting_drag_and_drop";
    ScenarioName["FileRemovalMeeting"] = "documents_remove_file_meeting";
    ScenarioName["FileAttachMeeting"] = "documents_attach_file_meeting";
    ScenarioName["FilesAMSImageUpload"] = "documents_ams_image_upload";
    // File Chiclet and Sharing
    ScenarioName["FileChicletDefaultPermission"] = "documents_share_link_chiclet_default_permission";
    ScenarioName["FileChicletExistingPermission"] = "documents_share_link_chiclet_existing_permission";
    ScenarioName["FileSharingPermissionDialog"] = "documents_share_link_permission_dialog";
    ScenarioName["FileSharingCopyLinkDialog"] = "documents_share_link_copy_dialog";
    // File chiclet actions
    ScenarioName["FileOpenInDesktopApp"] = "documents_action_open_office_file_app";
    ScenarioName["FileDownload"] = "documents_action_download_file";
    ScenarioName["FileOpenOnline"] = "documents_action_open_file_online";
    // Meeting options
    ScenarioName["MeetingOptionsCore"] = "meeting_options_core";
    ScenarioName["MeetingOptionsChanged"] = "meeting_options_changed";
    ScenarioName["MeetingOptionsStart"] = "meeting_options_start";
    ScenarioName["MeetingOptionsGet"] = "meeting_options_get";
    ScenarioName["MeetingOptionsSet"] = "meeting_options_set";
    // Messaging
    ScenarioName["AmsImageApiLoad"] = "ams_image_api_load";
    ScenarioName["AmsImageBrowserLoad"] = "ams_image_browser_load";
    ScenarioName["AmsImageUpload"] = "ams_image_upload";
    ScenarioName["OnDemandTranslation"] = "on_demand_translate_message";
    ScenarioName["AudioFileDownload"] = "audio_file_download";
    ScenarioName["PrivateChatPolicyDefined"] = "private_chat_policy_defined";
    // People Picker
    ScenarioName["PeoplePickerRemote"] = "people_picker_load_results";
    ScenarioName["PeoplePickerCache"] = "people_picker_load_results_clientonly";
    ScenarioName["PeoplePickerResolveUserRemote"] = "people_picker_resolve_user_remote";
    ScenarioName["PeoplePickerPstnAssignmentRemote"] = "people_picker_pstn_resolve_user_remote";
    ScenarioName["PeoplePicker3S"] = "people_picker_3s";
    ScenarioName["PeoplePickerAAD"] = "people_picker_aad";
    ScenarioName["PeoplePickerIDB"] = "people_picker_indexeddb";
    ScenarioName["PeoplePickerResolveUserOnSelection"] = "people_picker_resolve_user_on_selection";
    // Wiki
    ScenarioName["CreateWiki"] = "wikiv2_create_wiki";
    ScenarioName["LoadWiki"] = "wikiv2_load_wiki";
    ScenarioName["DeleteWiki"] = "wikiv2_delete_wiki";
    ScenarioName["SavePageTitleWiki"] = "wikiv2_save_page_title";
    ScenarioName["LockSectionWiki"] = "wikiv2_lock_section";
    ScenarioName["SaveSectionWiki"] = "wikiv2_save_section";
    ScenarioName["AddPageWiki"] = "wikiv2_add_page";
    ScenarioName["DeletePageWiki"] = "wikiv2_delete_page";
    ScenarioName["MovePageWiki"] = "wikiv2_move_page";
    ScenarioName["MoveSectionWiki"] = "wikiv2_move_section";
    ScenarioName["DeleteSectionWiki"] = "wikiv2_delete_section";
    ScenarioName["ForceUnlockWiki"] = "wikiv2_force_unlock";
    ScenarioName["AddSectionWiki"] = "wikiv2_add_section";
    ScenarioName["DiscardSectionWiki"] = "wikiv2_discard_section";
    ScenarioName["LoadPageWiki"] = "wikiv2_load_page";
    ScenarioName["FocusSectionWiki"] = "wikiv2_focus_section";
    ScenarioName["LoadPagesForSidebarWiki"] = "wikiv2_load_pages_for_sidebar";
    ScenarioName["LoadPageWithoutSectionWiki"] = "wikiv2_load_page_without_section";
    ScenarioName["LoadSectionWiki"] = "wikiv2_load_section";
    // Scheduler diagnostics
    ScenarioName["SyncJobScheduler"] = "sync_job_scheduler";
    // Sync Jobs
    ScenarioName["NoOpSyncJob"] = "noop_sync_job";
    ScenarioName["MessageSyncJob"] = "message_sync_job";
    ScenarioName["RelatedMessageSyncJob"] = "related_message_sync_job";
    ScenarioName["StartupSyncJob"] = "startup_sync_job";
    ScenarioName["ThreadDetailsSyncJob"] = "thread_details_sync_job";
    ScenarioName["BatchedThreadDetailsSyncJob"] = "batched_thread_details_sync_job";
    ScenarioName["ReplyChainSyncJob"] = "replychain_sync_job";
    // Pruning Jobs
    ScenarioName["PersistencePruningJob"] = "persistence_pruning_job";
    ScenarioName["RetentionPruningJob"] = "retention_pruning_job";
    ScenarioName["ActivityFeedPruningJob"] = "activity_feed_pruning_job";
    // Sync Workflows
    ScenarioName["MessageSyncWorkflow"] = "message_sync_workflow";
    ScenarioName["DeltaSyncWorkflow"] = "delta_sync_workflow";
    ScenarioName["ConversationSyncWorkflow"] = "conversation_sync_workflow";
    ScenarioName["ThreadDetailsWorkflow"] = "thread_details_workflow";
    ScenarioName["ReplyChainWorkflow"] = "reply_chain_workflow";
    ScenarioName["ExtendHistoryWorkflow"] = "extend_history_workflow";
    ScenarioName["RelatedMessageSyncWorkflow"] = "related_message_sync_workflow";
    // Other workflows
    ScenarioName["MaintenanceWorkflow"] = "maintenance_workflow";
    // Sync Strategies
    ScenarioName["OnActiveConversationStrategy"] = "on_active_conversation_strategy";
    ScenarioName["OnStartupOrIntervalStrategy"] = "on_startup_or_interval_strategy";
    ScenarioName["OnLoadMoreStrategy"] = "on_load_more_strategy";
    ScenarioName["OnLongPollReceivedStrategy"] = "on_long_poll_received_strategy";
    ScenarioName["OnAppStateActiveStrategy"] = "on_app_state_active_strategy";
    ScenarioName["OnAppStateInactiveStrategy"] = "on_app_state_inactive_strategy";
    ScenarioName["OnForceRunMaintenanceWorkflow"] = "on_force_run_maintenance_workflow";
    ScenarioName["OnPrefetchReplyChainsFromDb"] = "on_prefetch_reply_chains_from_db";
    // Manager
    ScenarioName["ReplyChainManagerGetReplyChains"] = "reply_chain_manager_get_reply_chains";
    ScenarioName["ReplyChainManagerGetReplyChain"] = "reply_chain_manager_get_single_reply_chain";
    ScenarioName["ReplyChainManagerGetReplyChainsByKeys"] = "reply_chain_manager_get_reply_chains_by_keys";
    // Resolvers
    ScenarioName["GetTeamsChannelsFromIndexedDB"] = "get_teams_channels_from_indexeddb";
    ScenarioName["PutLegacyMessagesResolver"] = "put_legacy_messages_resolver";
    ScenarioName["PutConversationsResolver"] = "put_conversations_resolver";
    ScenarioName["ResolveEditClientLieResolver"] = "resolve_edit_client_lie_resolver";
    // Gap Detection
    ScenarioName["OutOfOrderMessages"] = "gap_detection_out_of_order_messages";
    ScenarioName["MissingMessages"] = "gap_detection_missing_messages";
    ScenarioName["ArrivedAfterOutOfOrderWaitTime"] = "gap_detection_messages_arrived_after_outoforderwaittime";
    ScenarioName["MessagesGapAboveThreshold"] = "gap_detection_messages_gap_above_threshold";
    // AsyncIterableObserver
    ScenarioName["OnAsyncIterableObserverOverflow"] = "on_async_iterable_observer_overflow";
    // Core Settings
    ScenarioName["EcsFetch"] = "ecs_provider_fetch";
    ScenarioName["IPCPolicyFetch"] = "policy_service_fetch_ipc";
    ScenarioName["NetworkPolicyFetch"] = "policy_service_fetch_network";
    // Messaging
    ScenarioName["UpToEditBegin"] = "messaging_up_to_edit_message";
    ScenarioName["SmsDeliveryReportFailure"] = "sms_delivery_report_failure";
    // Message Extension
    ScenarioName["ExtMessageExtensionQueryCommand"] = "ext_me_queryCommand";
    // Card Actions
    ScenarioName["ExtBotsInvoke"] = "ext_bots_invoke";
    ScenarioName["ExtBotsMessageBack"] = "ext_bots_messageback";
    ScenarioName["ExtBotsCardActionChatSendMessage"] = "ext_bots_card_action_chat_send_message";
    ScenarioName["ExtBotsCardFetchTaskModule"] = "ext_bots_card_fetch_task_module";
    ScenarioName["ExtBotsCardTaskSubmit"] = "ext_bots_card_task_submit";
    // Platform tab
    ScenarioName["PlatformTabLoading"] = "platform_tab_loading";
    ScenarioName["PlatformTabWebviewCreation"] = "platform_tab_webview_creation";
    // Platform tab SDK
    ScenarioName["PlatformTabSdkGetAuthToken"] = "platform_tab_sdk_get_auth_token";
    ScenarioName["PlatformTabSdkGetContext"] = "platform_tab_sdk_get_context";
    ScenarioName["PlatformTabSdkGetUser"] = "platform_tab_sdk_get_user";
    // App definition queries used by cards
    ScenarioName["ExtAppDefinitionForMECard"] = "ext_app_definition_for_me_card";
    ScenarioName["ExtAppDefinitionsForBotCard"] = "ext_app_definitions_for_bot_card";
    // Share to Teams
    ScenarioName["RenderOutlookPreview"] = "render_outlook_preview";
    ScenarioName["RenderShareForm"] = "render_share_form";
    ScenarioName["ShareFormErrorBoundary"] = "share_form_error_boundary";
    ScenarioName["ShareFormFatalError"] = "share_form_fatal_error";
    ScenarioName["STTOutlookAddInStartup"] = "stt_outlook_add_in_startup";
    ScenarioName["STTOutlookPopulateUsage"] = "stt_outlook_populate_usage";
    ScenarioName["SubmitShareForm"] = "submit_share_form";
    // Calling
    ScenarioName["GetOngoingScenario"] = "get_ongoing_scenario";
    ScenarioName["AdjacentRoomBanner"] = "adjacent_room_banner";
    ScenarioName["ChatPaneFromCallRender"] = "chat_pane_from_call_render";
    ScenarioName["ShareTrayRender"] = "share_tray_render";
    ScenarioName["ShareTrayPreviewsLatency"] = "share_tray_previews_latency";
    ScenarioName["RosterPanelRender"] = "roster_panel_render";
    ScenarioName["CreateMeetingNotes"] = "create_meeting_notes";
    ScenarioName["UbarMicrophoneRerendered"] = "toggle_mute_latency";
    ScenarioName["RemoteMuteRender"] = "server_mute_latency";
    ScenarioName["ChangeRoleRender"] = "change_role_latency";
    ScenarioName["RemoveParticipantRender"] = "remove_participant_latency";
    ScenarioName["NudgeParticipantRender"] = "nudge_participant_latency";
    ScenarioName["ParticipantVbssLatency"] = "participant_vbss_latency";
    ScenarioName["LowerOtherParticipantsHandLatency"] = "lower_other_participants_hand_latency";
    // Bot Profile Picture
    ScenarioName["ExtBotProfilePictureUrl"] = "ext_bot_profile_picture_url";
    // Virtual List
    ScenarioName["VirtualListInitialStableView"] = "vl_initial_stable_view";
    ScenarioName["VirtualListLoadMore"] = "vl_load_more";
    ScenarioName["VirtualListNewRenderWindow"] = "vl_new_render_window";
    ScenarioName["VirtualListScrollToIndex"] = "vl_scroll_to_index";
    ScenarioName["VirtualListScrollToBottom"] = "vl_scroll_to_bottom";
    // App installation
    ScenarioName["InstallAppMessageExtensionJit"] = "ext_install_app_message_ext_jit";
    // App profile card
    ScenarioName["AppProfileCardGetAppDefinition"] = "app_profile_card_get_app_definition";
    // LMS Integration
    ScenarioName["LaunchLmsIntegration"] = "launch_lms_integration";
    ScenarioName["EnableSchoolDataSyncForCourse"] = "enable_school_data_sync_for_course";
    ScenarioName["GetTeamsForCourse"] = "get_teams_for_course";
    ScenarioName["LmsIntegrationErrorBoundary"] = "lms_integration_error_boundary";
    // App based link
    ScenarioName["AppBasedLinkInstall"] = "app_based_link_install";
})(ScenarioName || (ScenarioName = {}));
// Individual steps for the scenarios listed above
// standardized step names for shared perf/health dashboard
var StepName;
(function (StepName) {
    StepName["AppCacheMainJS"] = "appcache_main";
    StepName["AppCacheVendorJS"] = "appcache_vendor";
    StepName["DownloadScripts"] = "download_scripts";
    StepName["DownloadMainJs"] = "main";
    StepName["DownloadVendorJs"] = "vendor";
    StepName["EncodedBodySizeMainJS"] = "encoded_body_size_main";
    StepName["EncodedBodySizeVendorJS"] = "encoded_body_size_vendor";
    StepName["FetchData"] = "fetch_data";
    StepName["FetchQuerySend"] = "fetch_query_send";
    StepName["FetchWait"] = "fetch_wait";
    StepName["FetchProcessResponse"] = "fetch_process_response";
    StepName["Pause"] = "pause";
    StepName["Resume"] = "resume";
    StepName["Start"] = "start";
    StepName["Stop"] = "stop";
    StepName["QueryResult"] = "query_result";
    StepName["CdlWorkerBootstrapped"] = "cdl_worker_bootstrapped";
    StepName["CdlWorkerManagerLoaded"] = "cdl_worker_manager_loaded";
    StepName["CdlWorkerManagerHealthChecked"] = "cdl_worker_manager_health_checked";
    StepName["PlatformTabInitInvoke"] = "platform_tab_initialize_invoked";
    StepName["PlatformTabAppLoadedInvoke"] = "platform_tab_appLoaded_invoked";
    StepName["PlatformTabNotifySuccessInvoke"] = "platform_tab_success_invoked";
    StepName["PlatformTabNotifyFailureInvoke"] = "platform_tab_failure_invoked";
    // WLT Step Names:
    StepName["BeginWindowCreation"] = "begin_window_creation";
    StepName["EndWindowCreation"] = "end_window_creation";
    StepName["WindowContextProvider"] = "window_context_provider";
    StepName["RenderChatList"] = "render_chat_list";
    StepName["RenderChatPane"] = "render_chat_pane";
    StepName["RenderPlatformApp"] = "render_platform_app";
    StepName["PlatformFetchAppDefinition"] = "platform_fetch_app_definition";
    StepName["PlatformFetchTabInfo"] = "platform_fetch_tab_information";
    StepName["RenderProviders"] = "render_providers";
    StepName["RenderBaseApp"] = "render_base_app";
    StepName["RenderMessages"] = "render_messages";
    StepName["Unknown"] = "unknown";
    StepName["WindowCreated"] = "window_created";
    // Share to Teams
    StepName["STTDialogOpen"] = "stt_dialog_open";
    StepName["STTDialogTriggered"] = "stt_dialog_triggered";
    StepName["STTOutlookCallbackTokenComplete"] = "stt_outlook_callback_token_complete";
    StepName["STTOutlookMTCachedTokenComplete"] = "stt_outlook_mt_cached_token_complete";
    StepName["STTOutlookSSOComplete"] = "stt_outlook_sso_complete";
})(StepName || (StepName = {}));


/***/ })

}]);